import React, { useState } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import global from "../../../scss/dhp.scss";

import AssetName from "./Common/AssetName";
import AssetSearch from "./Common/AssetSearch";
import AssetCategory from "./Common/AssetCategory";
import AssetSchemeTypeNav from "./Common/AssetSchemeTypeNav";
import AssetLists from "./Common/AssetLists";
import { SOLO } from "../../../constants/editor";

let style = Object.assign({}, global);

const Illustration = props => {
  const illustrationSchemes = ["solo", "scene"];

  const [keyword, setKeyword] = useState("");
  const [category, setCategory] = useState("");
  const [schemeType, setSchemeType] = useState(SOLO);
  const [pageNumber, setPageNumber] = useState(1);
  const [isAssetFetched, setIsAssetFetched] = useState(false);
  const [availableAssetCategories, setAvailableAssetCategories] = useState([]);
  const [asstesLoading, setAsstesLoading] = useState();

  return (
    <div className={cx(style["editor-asset-inner"], style["illustration-asset"])}>
      <AssetName handleWidgetAction={props.handleWidgetAction} assetName={props.assetName} />

      <div className={style["pr-20"]}>
        <AssetSchemeTypeNav
          schemeTypeArray={illustrationSchemes}
          setSchemeType={setSchemeType}
          schemeType={schemeType}
          setPageNumber={setPageNumber}
          setIsAssetFetched={setIsAssetFetched}
          assetType={props.assetType}
        />

        <AssetSearch
          assetName={props.assetName}
          setKeyword={setKeyword}
          setCategory={setCategory}
          setPageNumber={setPageNumber}
          setIsAssetFetched={setIsAssetFetched}
          keyword={keyword}
        />

        <AssetCategory
          category={category}
          setCategory={setCategory}
          setKeyword={setKeyword}
          setPageNumber={setPageNumber}
          setIsAssetFetched={setIsAssetFetched}
          availableAssetCategories={availableAssetCategories}
          asstesLoading={asstesLoading}
        />
      </div>

      <AssetLists
        assetName={props.assetName}
        assetType={props.assetType}
        keyword={keyword}
        assetCategory={category}
        assetSchemeType={schemeType}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        isAssetFetched={isAssetFetched}
        setIsAssetFetched={setIsAssetFetched}
        setAvailableAssetCategories={setAvailableAssetCategories}
        asstesLoading={asstesLoading}
        setAsstesLoading={setAsstesLoading}
      />
    </div>
  );
};

//Props type validation
Illustration.propTypes = {
  handleWidgetAction: PropTypes.func.isRequired,
  assetName: PropTypes.string.isRequired,
  assetType: PropTypes.string.isRequired,
};
export default Illustration;
